export const EMAIL_PROFILE_RAW_MESSAGE_WHOM_LABELS = [
  'Email.ToLabelKey',
  'Email.CcLabelKey',
  'Email.BccLabelKey',
]

export const EMAIL_PROFILE_RAW_MESSAGE_DATE_FORMAT = 'ccc, MMM d, y h:mm a'
